import { LabelsMap } from 'new/form/common/types';

import { objectInformationSectionLabelsMap } from './sections/objectInformationSection/labels';
import { projectInformationSectionLabelsMap } from './sections/projectInformationSection/labels';

export const hausbankObjectInformationLabelsMap: LabelsMap = {
  ...objectInformationSectionLabelsMap,
  ...projectInformationSectionLabelsMap,
};
